export const RELEASE_VERSION = '4.8';
